import { render, staticRenderFns } from "./main.vue?vue&type=template&id=306e18a3&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306e18a3')) {
      api.createRecord('306e18a3', component.options)
    } else {
      api.reload('306e18a3', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=306e18a3&", function () {
      api.rerender('306e18a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/color-picker/src/main.vue"
export default component.exports